import { WebshopDesignInterface } from "../entities/Webshop";

export const getStylesFromTenant = (
  webshopDesignes: WebshopDesignInterface[] | null,
) => {
  const webshopDesign = webshopDesignes && webshopDesignes[0];
  if (webshopDesign) {
    const backgroundColor = webshopDesign.backgroundColor;
    const fontColor = webshopDesign.fontColor;
    return backgroundColor
      ? { backgroundColor, color: fontColor }
      : { backgroundColor: "rgba(255, 255, 255)", color: "#c282828" };
  }
  return { backgroundColor: "rgba(255, 255, 255)", color: "#282828" };
};

export const getLogoFromTenant = (
  webshopDesignes: WebshopDesignInterface[],
) => {
  const webshopDesign = webshopDesignes[0];
  return webshopDesign && webshopDesign.logo ? webshopDesign.logo : "";
};
